import { gql } from '@apollo/client'
import { CART_FRAGMENT } from '@/graphql/fragments/cart'
import { CONTACT_FRAGMENT } from '@/graphql/fragments/contact'
import { COUNTRY_CONFIG_FRAGMENT } from '@/graphql/fragments/countryConfig'
import { SOCIETY_FRAGMENT } from '@/graphql/fragments/society'
import { Cart } from '@/types/cart'
import { Contact } from '@/types/contact'
import { CountryConfig } from '@/types/countryConfig'
import { SocietyType } from '@/types/society'

export interface NavigationDataType {
  countryConfig: CountryConfig | null
  society: SocietyType | null
  contact: (Contact & { userPresent: boolean }) | null
  address: { id: string } | null
  currentCart: Cart | null
  domiciliation: { id: string; paid: boolean } | null
}

// Prospect data the funnel steps are derived from; the fragments of the steps keep the Apollo cache normalized
export const NAVIGATION_QUERY = gql`
  query prospectNavigation {
    countryConfig {
      ...CountryConfigFragment
    }
    society {
      ...SocietyFragment
    }
    contact {
      ...ContactFragment
      userPresent
    }
    address {
      id
    }
    currentCart {
      ...CartFragment
    }
    domiciliation {
      id
      paid
    }
  }
  ${CONTACT_FRAGMENT}
  ${SOCIETY_FRAGMENT}
  ${COUNTRY_CONFIG_FRAGMENT}
  ${CART_FRAGMENT}
`
